import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthTheme, getAuthStyles, injectAuthKeyframes } from './AuthTheme';
import { useAuth } from '../../context/AuthContext';

injectAuthKeyframes();

const PARTICLES = [
  { top: '10%', left: '8%', animationDelay: '0s' },
  { top: '20%', right: '10%', animationDelay: '1s' },
  { top: '60%', left: '5%', animationDelay: '2s' },
  { bottom: '20%', right: '8%', animationDelay: '0.5s' },
  { bottom: '10%', left: '20%', animationDelay: '1.5s' },
  { top: '45%', right: '5%', animationDelay: '2.5s' },
];

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { dark } = useAuthTheme();
  const { login } = useAuth();
  const s = getAuthStyles();

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    if (!email.trim()) { setError('Email is required'); setLoading(false); return; }
    if (!password.trim()) { setError('Password is required'); setLoading(false); return; }
    try {
      const result = await login(email, password, 'admin');
      if (result?.success) navigate('/dashboard');
      else setError(result?.error || 'Invalid credentials');
    } catch { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.orb1} /><div style={s.orb2} /><div style={s.orb3} />
      <div style={s.particles}>
        {PARTICLES.map((p, i) => <div key={i} style={{ ...s.particle, ...p }} />)}
      </div>

      <div style={s.wrap}>
        <div style={s.brand} onClick={() => navigate('/')}>
          <div style={s.logoRing}><span style={s.logoEmoji}>👨‍💼</span><div style={s.logoGlow} /></div>
          <h1 style={s.brandName}>UniResolve</h1>
          <p style={s.brandSub}>Admin Portal</p>
        </div>

        <div style={s.card}>
          <div style={s.cardTop}><div style={s.cardTopBadge}>👨‍💼 Admin Login</div></div>
          <div style={s.cardBody}>
            <h2 style={s.heading}>Admin Access</h2>
            <p style={s.sub}>Department Admin · University Admin</p>

            <div style={s.infoBox}>
              <span>ℹ️</span>
              <span style={s.hintText}>Admin accounts are created by the Authority. Contact your authority if you need access.</span>
            </div>

            <form onSubmit={handleSubmit}>
              {error && <div style={s.err}><span>⚠️ {error}</span><button type="button" onClick={() => setError('')} style={s.errX}>×</button></div>}
              <div style={s.field}>
                <label style={s.label}>Admin Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="e.g. xyz@admin.edu" style={s.input} required />
              </div>
              <div style={s.field}>
                <label style={s.label}>Password</label>
                <div style={s.pwWrap}>
                  <input type={showPw ? 'text' : 'password'} value={password}
                    onChange={e => setPassword(e.target.value)} placeholder="Enter your password" style={s.input} required />
                  <button type="button" onClick={() => setShowPw(!showPw)} style={s.pwBtn}>{showPw ? 'Hide' : 'Show'}</button>
                </div>
              </div>
              <button type="submit" disabled={loading} style={{ ...s.btn, ...(loading ? s.btnOff : {}) }}>
                {loading ? <span style={s.btnIn}><span style={s.spin} /> Signing in...</span> : 'Access Admin Dashboard'}
              </button>
            </form>
          </div>
        </div>
        <p style={s.footer}>© 2026 UniResolve</p>
      </div>
    </div>
  );
}
